import type { ViewportLike } from "./pdfKoordinaten";
import type { ViewerLike } from "./EntfernenEbene";

/**
 * Schmale Schnittstelle zu den gerenderten Seiten — damit die Kommentar-Ebene
 * im Lese-Viewer (react-pdf) und im Editor (PDF.js-`PDFViewer`) dieselbe ist.
 *
 * - `seitenElement(i)`: das positionierte Element der Seite i (0-basiert), in
 *   das die Ebene ihre Markierungen hängt. Seine Box = Inhaltsfläche der Seite.
 * - `viewport(i)`: Umrechnung Userspace ↔ CSS-Pixel relativ zu diesem Element.
 * - `onAenderung`: Zoom, Neuzeichnen, neue Seiten — die Ebene rechnet neu.
 */
export interface SeitenGeometrie {
    anzahl(): number;
    seitenElement(i: number): HTMLElement | null;
    viewport(i: number): ViewportLike | null;
    onAenderung(cb: () => void): () => void;
}

const PDFJS_EREIGNISSE = ["pagerendered", "textlayerrendered", "scalechanging", "rotationchanging", "pagesinit"];

/** Editor: aus dem PDF.js-`PDFViewer` (wie `EntfernenEbene`). */
export function pdfJsGeometrie(viewer: ViewerLike): SeitenGeometrie {
    return {
        anzahl: () => viewer.pagesCount,
        seitenElement: (i) => viewer.getPageView(i)?.div ?? null,
        viewport: (i) => viewer.getPageView(i)?.viewport ?? null,
        onAenderung: (cb) => {
            for (const e of PDFJS_EREIGNISSE) viewer.eventBus.on(e, cb);
            return () => {
                for (const e of PDFJS_EREIGNISSE) viewer.eventBus.off(e, cb);
            };
        },
    };
}
